import type { IPromiseBasedObservable } from "mobx-utils";
import type { IModalInstance, Modal } from "@whatslly/ui-components/modals/ModalService";
import type { ClientSideSidecar, CreateSidecar, GetSidecarStatus } from "@whatslly/types/sidecars-server/Sidecar";
import type { SidecarInitPairingMode } from "@whatslly/types/sidecars-server/SidecarUrlParams";
import type { ChangeModeToState, PairingIdentification } from "./types";

export type PairingModalProps = IModalInstance<false> & {
  restartPairing: () => void;
  sidecarId: string;
  store: ISidecarPairingStore;
  cancelable?: boolean;
  onClose: VoidFunction;
  runnerChannel: Exclude<CreateSidecar["channelType"], undefined>;
};

export interface ISidecarPairingStore {
  // Observable properties
  pairingSidecar?: GetSidecarStatus;
  isPaired: boolean;
  phoneCountryCode: string;
  pairingPhone: string;
  changeModeToState?: ChangeModeToState;
  initialPairingMode: SidecarInitPairingMode;
  initializePromise:
    | Promise<{
        success: boolean;
        pairing?: boolean;
        modal?: Modal<PairingModalProps>;
      }>
    | undefined;

  // Computed properties
  changeModeRequest: IPromiseBasedObservable<ChangeModeToState>;

  // Methods
  initialize(
    sidecarId: string,
    identification: PairingIdentification,
    initPairingMode: SidecarInitPairingMode
  ): Promise<{
    success: boolean;
    pairing?: boolean;
    modal?: Modal<PairingModalProps>;
  }>;
  setSidecar(status: GetSidecarStatus): boolean;
  pairSidecar(
    sidecarId: string,
    pairingToken: string,
    initPairingMode: SidecarInitPairingMode,
    runnerChannel: Exclude<CreateSidecar["channelType"], undefined>
  ): Promise<void>;
  pairExistingSidecar(sidecar: ClientSideSidecar, etoken: string): Promise<false | undefined>;
  changeMode(toState: ChangeModeToState): Promise<void>;
  setCountryCode(countryCode: string): void;
  setPairingPhone(phone: string): void;
}

export const InjectSidecarPairingStore = Symbol.for("SidecarPairingStore");
